var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cont"},_vm._l((_vm.imglist),function(i){return _c('img',{key:i,attrs:{"src":i}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }